exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-form-dialog[data-v-dee18fea] .el-dialog__body{padding-top:5px;padding-bottom:10px;max-height:calc(100vh - 280px);overflow-y:auto}.price-form-dialog[data-v-dee18fea] .el-dialog__body .height-block{min-height:366px;max-height:calc(100vh - 420px);overflow-y:auto}\n", ""]);

// exports
